const multiAccessClientState = {
  company: '',
  multiaccess: {
    clientCanLogin: true,
    contractsManagedBy: 'client',
    clientReference: null,
    isDailyAccount: false,
    clientMarkets: [],
  },
  lastName: '',
  firstName: '',
  username: '',
  phone: '',
};

export default multiAccessClientState;
